import React from "react";
import StoresContext from "../../context/storesContext";

const WithCommissionedLightingStores = Component => {
  return class extends React.Component {
    render() {
      return (
        <StoresContext.Consumer>
          {({ stores, onLightingStoresChange }) => (
            <Component
              stores={stores.lighting.filter(
                store => store.isCommissioned === true
              )}
              onLightingStoresChange={onLightingStoresChange}
              {...this.props}
            />
          )}
        </StoresContext.Consumer>
      );
    }
  };
};

export default WithCommissionedLightingStores;
